import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { MaterialType } from "../../../../../types/materialType";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditMaterialType: (id: number | string) => void;
  onDeleteMaterialType: (id: number | string) => void;
  onViewMaterialType: (id: number | string) => void;
  data: MaterialType[];
  [x: string]: any;
}
export default function DataTable({
  onEditMaterialType,
  onDeleteMaterialType,
  onViewMaterialType,
  data,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Material Type - Maintenance") ||
            hasClaim("Material Type - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_TIPO_MATERIAL}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewMaterialType(row.ID_TIPO_MATERIAL)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Material Type - Maintenance") ? "block" : "none",
        }}
        key={`edit-${row.ID_TIPO_MATERIAL}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditMaterialType(row.ID_TIPO_MATERIAL)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Material Type - Maintenance") ? "block" : "none",
        }}
        key={`delete-${row.ID_TIPO_MATERIAL}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteMaterialType(row.ID_TIPO_MATERIAL)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "DESCRICAO",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      flex: 4,
    },
    {
      field: "CODIGO_EDI",
      headerName: "EDI Code",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      width: 100,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_TIPO_MATERIAL)}
        data-testid="materialType-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
